/* eslint-disable import/first */
import React from 'react';

import { Radio } from '@material-ui/core';

/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import formatRelative from 'date-fns/formatRelative';
import { FormattedMessage, useIntl } from 'react-intl';
import enGB from 'date-fns/locale/en-GB';
import noImg from '../../assets/no-itm.png';

const { selectBaseURL, selectCountryValidations } = Slices.configSlice;
import { AiOutlineDown } from '@react-icons/all-files/ai/AiOutlineDown';
const { selectCurrentCountry } = Slices.profileSlice;
const { selectDefaultAddress } = Slices.addressSlice;
// import { Clock } from '../../components/Icons';
import ClassNames from 'classnames';
import css from './index.module.scss';
import foicon from './images/futureordericon.svg';
import classNames from 'classnames';

const OrderMode = ({
  isDesktop,
  selectedValue,
  selectedDate,
  onChange,
  setFutureDrawer,
  selectedTime,
  methodType,
  setPaymentMode,
  futureError,
}) => {
  const intl = useIntl();
  const address = useSelector(selectDefaultAddress);
  const imgBaseUrl = useSelector(selectBaseURL);
  const country = useSelector(selectCurrentCountry);
  const configData = useSelector((state) => selectCountryValidations(state, country));

  if (!Object.entries(address).length) return '';

  const addMode = configData.addressType;

  const addressIndex = addMode ? addMode.findIndex(({ type }) => type === address.addressType) : '';
  const subType = addMode ? addMode.findIndex(({ type }) => type === address.addressSubType) : '';
  let iconImg;
  if (addressIndex !== -1 && subType !== -1) {
    iconImg = addMode[addressIndex].subType[0].imageAlt;
  } else if (addressIndex !== -1 && subType === -1) {
    const findSub = addMode
      ? addMode[addressIndex].subType?.findIndex(({ type }) => type === address.addressSubType)
      : '';
    iconImg = addMode[addressIndex].subType[findSub].imageAlt;
  }
  const formatRelativeLocale = {
    lastWeek: "'Last' eeee",
    yesterday: "'Yesterday' | hh:mm a",
    today: "'Today' | hh:mm a",
    tomorrow: "'Tomorrow' | hh:mm a",
    nextWeek: "'Next' eeee",
    other: 'dd MMM, yyy , hh:mm a',
  };

  const locale = {
    ...enGB,
    formatRelative: (token) => formatRelativeLocale[token],
  };
  const ab = parseISO(selectedTime);
  const selectVal = formatRelative(selectedDate, new Date(), { locale }).split('|');

  const showFutureOrderBox = () => {
    if (methodType == intl.formatMessage({ id: 'checkout_pod' })) {
      setPaymentMode(null);
    }
    setFutureDrawer(true);
  };

  return (
    <div className={css.section}>
      <div className={css.deliveryMod}>
        {isDesktop && (
          <h3 className={css.orderModeText}>
            <FormattedMessage id="order_mode_text" defaultMessage="When do you want this order?" />
          </h3>
        )}
        <div className={css.modeWrapper}>
          <div className={css.modCol}>
            <div className={css.orderModes}>
              <div className={classNames(css.deliveryOption, css.cardWrap)}>
                <div className={css.iconCol}>
                  <img
                    src={`${imgBaseUrl.home}${iconImg}`}
                    alt="Delivery Icon"
                    className={css.icon}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImg;
                    }}
                  />
                </div>
                <label className={css.modTitle} for="radio_now">
                  {address.addressSubType === 'STORE' && (
                    <FormattedMessage id="checkout_selfpickup" defaultMessage="Self Pickup Now" />
                  )}
                  {address.addressSubType === 'CARHOP' && (
                    <FormattedMessage id="carhopNow" defaultMessage="Carhop Now" />
                  )}
                  {address.addressSubType === 'DRIVETHRU' && (
                    <FormattedMessage id="driveThruNow" defaultMessage="Drive-thru Now" />
                  )}
                  {address.addressSubType === 'DINEIN' && (
                    <FormattedMessage id="dineInNow" defaultMessage="Dine-in Now" />
                  )}
                  {address.addressSubType === 'DELIVERY' && (
                    <FormattedMessage id="checkout_delivernow" defaultMessage="Deliver Now" />
                  )}
                </label>
                <Radio
                  className={css.radioButton}
                  checked={selectedValue === 'now'}
                  onChange={onChange}
                  value="now"
                  color="primary"
                  name="deliveryMode"
                  inputProps={{ id: 'radio_now' }}
                />
              </div>
              {/* <hr /> */}
              <div className={css.cardWrap}>
                <div
                  className={ClassNames(css.deliveryOption, {
                    [css.disableGrid]: !configData.advanceOrder || futureError !== '',
                  })}
                >
                  <figure className={css.futureOrderIcon}>
                    <img src={foicon} alt="Future order Icon" />
                  </figure>
                  <label className={css.modTitle} for="radio_future" onClick={showFutureOrderBox}>
                    <span>
                      <FormattedMessage id="checkout_futureorder" defaultMessage="Future Order" />
                      {/* <span className={css.clockIcon}>
                        <Clock />
                      </span> */}
                    </span>
                    {configData.advanceOrder && selectedValue === 'future' && selectedDate ? (
                      <div className={css.futureValueDisktop} onClick={showFutureOrderBox}>
                        <div className={css.subTitle}>
                          {selectedDate ? selectVal[0] : ''} |{' '}
                          {selectedTime ? format(ab, 'hh:mm a') : ''}
                          <div className={css.icon}>
                            <AiOutlineDown />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className={css.futureValueDisktop}>
                        <div className={css.title}>
                          {!configData.advanceOrder || futureError !== '' ? (
                            <FormattedMessage
                              id="checkout_futureorderUnavailable"
                              defaultMessage="Currently unavailable."
                            />
                          ) : (
                            <FormattedMessage
                              id={`checkout_datetimedelivery_${address.addressSubType.toLowerCase()}`}
                              defaultMessage="Select Date & Time of Delivery"
                            />
                          )}

                          {/* <FontAwesomeIcon className={css.arrowRight} icon={faArrowRight} /> */}
                        </div>
                      </div>
                    )}
                  </label>
                  <Radio
                    // className={css.radioButton}
                    checked={selectedValue === 'future'}
                    onChange={onChange}
                    value="future"
                    disabled={!configData.advanceOrder}
                    color="primary"
                    name="deliveryMode"
                    inputProps={{ id: 'radio_future' }}
                    onClick={showFutureOrderBox}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderMode;
